import styled from 'styled-components'
import { withProp } from 'styled-tools'
import sortedBullets from '@images/sorted_bullets.png'
import colorsOptions, {
  applyOpacity
} from '../../components/stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: ${(props) => props.topHeight}px;
  bottom: 0;
  overflow: hidden;
  z-index: 990;
`

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  background: rgba(0, 0, 0, 0.4);
  transition: opacity 0.5s;
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
`
export const MobilePopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 995;
  background: rgba(0, 0, 0, 0.4);
  transition: opacity 0.5s;
  opacity: ${(props) => (props.visible ? '1' : '0')};
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
`

export const AppDiv = styled.div`
  overflow: ${({ overflowHidden }) => (overflowHidden ? 'hidden' : 'auto')};
`

export const Page = styled.div`
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
  transition: opacity 0.5s;
`

export const PostBarBottom = styled.div`
  position: absolute;
  z-index: 2;
  background: ${applyOpacity(colorsOptions.greys['grey-100'], 0.4)};
  ${({ top }) => (top ? 'top: 0' : 'bottom: 0')};
  opacity: ${({ isMobile, showArrows }) => (!isMobile || showArrows ? '1' : 0)};
  visibility: ${withProp(['isMobile', 'showArrows'], (isMobile, showArrows) =>
    !isMobile || showArrows ? 'visible' : 'hidden'
  )};
  width: 100%;
  transition: all 0.3s;
  padding: 8px 8px;
  .userInfo {
    .userText {
      margin-left: 50px;
      .bold {
        color: ${colorsOptions.greys.white};
        ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
        ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
        background: url('${sortedBullets}') no-repeat 96% 7px;
        padding: 0 17px 0 0;
        margin-right: 10px;
      }
      .info {
        color: ${colorsOptions.greys['grey-50']};
        ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
        ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
      }
    }
  }
`

export const PopupInside = styled.div`
  padding: 15px 16px 15px;
`

export const BA = styled.a`
  cursor: pointer;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.docuToolsOrange.orange};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`
